var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("首页")]),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("关于我们")]),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("登录")]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }